/* Savia Nature home effects: scroll reveal + stat count-up.
   Tasteful, editorial, and fully disabled under prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  /* ---- Scroll reveal: top-level sections rise and fade in (homepage only) ---- */
  if (document.querySelector('.sv-hero')) {
  var sections = Array.prototype.slice.call(
    document.querySelectorAll('main .shopify-section')
  );
  sections.forEach(function (el, i) {
    // Skip the hero so above-the-fold paints instantly.
    if (el.querySelector('.sv-hero')) return;
    el.classList.add('sv-reveal');
  });

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sv-reveal--in');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  document.querySelectorAll('.sv-reveal').forEach(function (el) {
    revealObserver.observe(el);
  });
  }

  /* ---- Stat count-up (any page with stats) ---- */
  function animateValue(el) {
    var raw = el.getAttribute('data-sv-value') || el.textContent.trim();
    var match = raw.match(/^([^0-9]*)([\d,]+)(.*)$/);
    if (!match) return; // non-numeric (e.g. "Oct 29") stays static
    var prefix = match[1];
    var target = parseInt(match[2].replace(/,/g, ''), 10);
    var suffix = match[3];
    if (isNaN(target)) return;
    var start = null;
    var duration = 1100;
    function fmt(n) {
      return prefix + n.toLocaleString('en-US') + suffix;
    }
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(eased * target));
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    }
    el.setAttribute('data-sv-value', raw);
    el.textContent = fmt(0);
    requestAnimationFrame(step);
  }

  var statObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateValue(entry.target);
          statObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.6 }
  );
  document.querySelectorAll('.sv-stat__value').forEach(function (el) {
    statObserver.observe(el);
  });
})();
